module.exports = __webpack_public_path__ + "static/DisabledOverseas-e4191090da8cdc4670ce06849237ccc5.png";